<div *ngIf="!isLoadingLabels">
	<div class="forgot-password-container container" id="forgot-password-container">
		<div class="logos"><img src="assets/images/Atos.svg" /></div>

		<div *ngIf="!isLoadingEmail" class="forgot-password-bubble">
			<pcp-password-reset [email]="email"></pcp-password-reset>
		</div>
	</div>

	<img class="blue-login-ball" src="assets/images/BolinhaAzul.svg" />
	<img class="orange-login-ball" src="assets/images/BolinhaRosa.svg" />
</div>
